import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export default function Hero() {
  const heroBg =
    "https://static.prod-images.emergentagent.com/jobs/28cee804-7d68-4152-8a35-a5557411301b/images/65cf0d502fc2ce09e70877229cf97d15fa43f443da523ddd3e236ef29c47c298.png";

  return (
    <section
      data-testid="hero-section"
      className="relative pt-28 md:pt-32 lg:pt-36 pb-12 md:pb-20 border-b border-damita-border overflow-hidden"
    >
      <div className="absolute inset-0 -z-10">
        <img src={heroBg} alt="" className="w-full h-full object-cover opacity-25" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/60 to-white/0" />
        <div className="absolute inset-0 blueprint-bg opacity-50" />
      </div>

      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 mb-10 md:mb-14">
          <div className="col-span-12 md:col-span-7 flex flex-wrap items-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.22em] font-mono text-damita-ink2">
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 bg-damita-yellow flicker" /> Est. 2017
            </span>
            <span>Udyam-Registered Startup</span>
            <span className="hidden md:inline">Delta Authorized Partner</span>
          </div>
          <div className="hidden md:flex col-span-5 items-center justify-end gap-3 text-[11px] uppercase tracking-[0.22em] font-mono text-damita-ink2">
            <span>Agartala, Tripura</span>
            <span className="w-12 tick-line" />
            <span>NE + E India</span>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 lg:gap-12">
          <div className="col-span-12 lg:col-span-9">
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-damita-blue mb-6">
              / Bada Biplab Power Solutions
            </div>
            <h1 className="font-display font-black text-[44px] sm:text-6xl lg:text-[104px] leading-[0.9] tracking-tighter text-damita-ink">
              <span className="text-damita-blue">BB Power.</span><br />
              Complete power solution for IT &amp; industrial applications.
            </h1>
          </div>

          <div className="col-span-12 lg:col-span-3 flex flex-col justify-end gap-6">
            <p className="text-base md:text-lg leading-relaxed text-damita-ink2 max-w-md">
              UPS, batteries, solar, panels, data-centre cooling and turnkey commissioning —
              engineered for the East and Northeast.
            </p>
            <div className="flex flex-col sm:flex-row lg:flex-col gap-3">
              <Link
                data-testid="hero-cta-products"
                to="/products"
                className="inline-flex items-center justify-between gap-3 bg-damita-blue text-white px-5 py-4 font-semibold hover:bg-damita-blueHover transition-all btn-press"
              >
                Explore our products
                <ArrowRight size={18} />
              </Link>
              <Link
                data-testid="hero-cta-quote"
                to="/contact"
                className="inline-flex items-center justify-between gap-3 bg-damita-yellow text-white px-5 py-4 font-semibold hover:bg-[#D96B12] transition-all btn-press"
              >
                Request a quote
                <ArrowUpRight size={18} />
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-2 md:grid-cols-4 border-t border-l border-damita-blue">
          {[
            { k: "8+", l: "Years Operating", c: "ink" },
            { k: "12", l: "States Served", c: "blue" },
            { k: "100+", l: "Projects Delivered", c: "ink" },
            { k: "24/7", l: "Emergency Support", c: "yellow" },
          ].map((s) => (
            <div key={s.l} className="border-r border-b border-damita-blue p-5 md:p-7 bg-white">
              <div
                className={`font-display font-black text-3xl md:text-5xl tracking-tighter ${
                  s.c === "blue" ? "text-damita-blue" : s.c === "yellow" ? "text-damita-yellow" : "text-damita-ink"
                }`}
              >
                {s.k}
              </div>
              <div className="text-[11px] uppercase tracking-[0.2em] font-mono text-damita-ink2 mt-2">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
